import { getGeoInfo } from "_services/country";
import { getCountries } from "react-phone-number-input";
import countryNamesEN from "react-phone-number-input/locale/en.json";
import { getCookie } from "./cookies";

export const getCountriesList = async () => {

  const hutk = getCookie('hubspotutk')
  let countryCode: string | undefined;
  if(hutk){
    const geoInfoResponse = await getGeoInfo();
    countryCode = geoInfoResponse?.data?.country_code;
  }

  if (!countryCode) {
    countryCode = 'US';
  }

  const cn = getCountries();
  const countries = cn
    .map(item => {
      return {
        name: countryNamesEN[item],
        code: item
      };
    })
    .sort((a, b) =>
      a.name.localeCompare(b.name, "en", {
        sensitivity: "base"
      })
    );

  const myCountry = countries.find(
    country => country.code === countryCode
  );
  const myCountryIndex = countries.findIndex(
    country => country.code === countryCode
  );
  const countriesWithMyCountry = [...countries];
  countriesWithMyCountry.splice(myCountryIndex, 1);
  if (myCountry !== undefined) {
    countriesWithMyCountry.unshift(myCountry);
  }

  return countriesWithMyCountry;
};